export const hasStringPlaceholder = (value: unknown): boolean =>
  typeof value === 'string' && value.includes('{{');
